var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with ImageTracer.java version 1.1.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 0",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 0.0 L 18.0 0.5 L 14.0 3.5 L 13.0 8.5 Q 15.3 9.8 14.0 14.5 L 15.5 31.0 L 21.0 92.5 L 24.0 126.5 L 25.0 143.5 L 26.0 147.5 L 26.5 155.0 L 29.0 181.5 L 30.0 192.5 Q 29.8 200.8 34.5 204.0 L 60.5 212.0 L 106.0 224.5 L 0.5 225.0 L 0.5 0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 0",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 0.0 L 158.5 0.0 L 193.5 0.0 L 202.5 0.0 Q 208.9 0.1 211.0 4.5 L 208.0 48.5 Q 205.8 49.8 207.0 54.5 L 205.0 76.5 L 198.5 150.0 L 195.5 183.0 L 195.0 193.5 Q 194.3 201.8 188.5 205.0 L 136.0 219.5 L 123.5 223.0 L 116.0 224.5 L 109.5 225.0 L 58.5 211.0 L 41.5 206.0 Q 34.3 205.8 32.0 200.5 Q 28.6 194.4 30.0 183.5 L 29.0 180.5 L 29.0 172.5 Q 26.8 171.3 28.0 166.5 L 26.5 150.0 L 17.5 49.0 L 15.0 20.5 L 14.0 4.5 L 19.5 0.0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 1",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 0.0 L 225.0 0.5 L 224.5 225.0 L 119.0 224.5 L 170.0 210.5 L 182.5 207.0 Q 189.1 206.6 192.0 202.5 Q 195.7 199.7 195.0 192.5 L 196.0 181.5 L 198.5 155.0 L 199.0 147.5 L 200.0 143.5 L 201.0 126.5 L 203.0 104.5 L 212.0 6.5 L 208.5 1.0 L 207.5 0.0 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 0",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 1.0 L 14.5 4.0 L 16.5 1.0 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 1",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 1.0 L 210.5 4.0 L 208.5 1.0 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 2",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 13.5 6.0 L 14.0 8.5 L 13.0 8.5 L 13.5 6.0 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 3",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 6.0 L 212.0 8.5 L 211.0 8.5 L 211.5 6.0 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 4",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 14.5 15.0 L 15.0 19.5 L 14.0 19.5 L 14.5 15.0 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 5",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 15.0 L 211.0 19.5 L 210.0 19.5 L 210.5 15.0 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 6",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 15.5 26.0 L 16.0 30.5 L 15.0 30.5 L 15.5 26.0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 7",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 26.0 L 210.0 30.5 L 209.0 30.5 L 209.5 26.0 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 8",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 38.0 L 17.0 42.5 L 16.0 42.5 L 16.5 38.0 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 9",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 38.0 L 209.0 42.5 L 208.0 42.5 L 208.5 38.0 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 10",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 43.0 L 173.0 43.5 L 52.5 44.0 L 52.5 43.0 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 2",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 44.0 L 174.0 44.5 L 175.0 46.5 L 174.0 51.5 L 173.0 60.5 L 171.5 68.0 L 136.0 82.5 L 127.5 86.0 Q 121.6 86.6 119.0 90.5 Q 120.8 93.8 127.5 92.0 L 149.5 92.0 L 158.5 92.0 Q 164.7 91.3 167.0 94.5 L 169.0 101.5 L 168.0 104.5 L 167.5 111.0 L 164.0 143.5 L 163.0 153.5 L 162.5 158.0 L 160.5 164.0 L 132.0 174.5 L 119.5 179.0 Q 116.6 181.6 110.5 181.0 L 81.0 170.5 L 72.0 167.5 L 64.0 163.5 L 62.0 153.5 L 60.5 140.0 L 60.0 130.5 Q 61.0 127.0 66.5 128.0 L 78.5 128.0 Q 81.5 128.5 81.0 132.5 L 82.0 136.5 Q 81.0 144.5 83.5 149.0 L 112.5 159.0 L 142.0 148.5 L 146.0 114.5 L 82.5 114.0 L 66.5 114.0 Q 60.4 115.1 58.0 112.5 L 56.5 103.0 L 56.0 92.5 L 61.5 89.0 L 70.5 86.0 L 113.0 67.5 L 111.5 65.0 L 68.5 65.0 L 57.5 65.0 Q 53.0 66.0 52.0 63.5 L 51.0 52.5 Q 52.3 47.8 50.0 46.5 L 51.5 44.0 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 11",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 47.0 L 51.0 50.5 L 50.0 50.5 L 50.5 47.0 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 12",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 47.0 L 175.0 50.5 L 174.0 50.5 L 174.5 47.0 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 13",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 49.0 L 18.0 53.5 L 17.0 53.5 L 17.5 49.0 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 14",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 49.0 L 208.0 53.5 L 207.0 53.5 L 207.5 49.0 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 15",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 56.0 L 174.0 59.5 L 173.0 59.5 L 173.5 56.0 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 16",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 57.0 L 52.0 60.5 L 51.0 60.5 L 51.5 57.0 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 17",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 60.0 L 19.0 64.5 L 18.0 64.5 L 18.5 60.0 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 18",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 60.0 L 207.0 64.5 L 206.0 64.5 L 206.5 60.0 Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 19",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 65.0 L 112.0 65.5 L 54.5 66.0 L 54.5 65.0 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 20",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 65.0 L 173.0 67.5 L 172.0 67.5 L 172.5 65.0 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 21",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 67.0 L 111.5 69.0 L 112.5 67.0 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 22",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 71.0 L 206.0 75.5 L 205.0 75.5 L 205.5 71.0 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 23",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 72.0 L 20.0 75.5 L 19.0 75.5 L 19.5 72.0 Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 24",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 82.0 L 21.0 87.5 L 20.0 87.5 L 20.5 82.0 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 25",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 82.0 L 205.0 87.5 L 204.0 87.5 L 204.5 82.0 Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 26",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 93.0 L 56.0 96.5 L 55.0 96.5 L 55.5 93.0 Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 27",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 94.0 L 22.0 97.5 L 21.0 97.5 L 21.5 94.0 Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 28",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 94.0 L 204.0 97.5 L 203.0 97.5 L 203.5 94.0 Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 29",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 102.0 L 169.0 105.5 L 168.0 105.5 L 168.5 102.0 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 30",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 103.0 L 57.0 106.5 L 56.0 106.5 L 56.5 103.0 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 31",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 105.0 L 23.0 109.5 L 22.0 109.5 L 22.5 105.0 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 32",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 105.0 L 203.0 109.5 L 202.0 109.5 L 202.5 105.0 Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 33",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 111.0 L 168.0 114.5 L 167.0 114.5 L 167.5 111.0 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 34",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 114.0 L 146.0 116.5 L 145.0 116.5 L 145.5 114.0 Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 35",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 116.0 L 24.0 120.5 L 23.0 120.5 L 23.5 116.0 Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 36",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 116.0 L 202.0 120.5 L 201.0 120.5 L 201.5 116.0 Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 37",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 121.0 L 167.0 124.5 L 166.0 124.5 L 166.5 121.0 Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 38",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 122.0 L 145.0 125.5 L 144.0 125.5 L 144.5 122.0 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 39",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 127.0 L 25.0 131.5 L 24.0 131.5 L 24.5 127.0 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 40",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 127.0 L 78.0 127.5 L 63.5 128.0 L 63.5 127.0 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 41",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 127.0 L 201.0 131.5 L 200.0 131.5 L 200.5 127.0 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 42",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 128.0 L 60.5 130.0 L 61.5 128.0 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 43",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 128.0 L 80.5 130.0 L 79.5 128.0 Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 44",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 130.0 L 166.0 133.5 L 165.0 133.5 L 165.5 130.0 Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 45",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 131.0 L 60.0 134.5 L 59.0 134.5 L 59.5 131.0 Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 46",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 131.0 L 144.0 135.5 L 143.0 135.5 L 143.5 131.0 Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 47",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 132.0 L 82.0 135.5 L 81.0 135.5 L 81.5 132.0 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 48",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 139.0 L 26.0 143.5 L 25.0 143.5 L 25.5 139.0 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 49",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 139.0 L 165.0 143.5 L 164.0 143.5 L 164.5 139.0 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 50",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 139.0 L 200.0 143.5 L 199.0 143.5 L 199.5 139.0 Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 51",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 140.0 L 61.0 143.5 L 60.0 143.5 L 60.5 140.0 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 52",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 141.0 L 83.0 144.5 L 82.0 144.5 L 82.5 141.0 Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 53",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 141.0 L 143.0 144.5 L 142.0 144.5 L 142.5 141.0 Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 54",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 149.0 L 62.0 152.5 L 61.0 152.5 L 61.5 149.0 Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 55",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 149.0 L 164.0 152.5 L 163.0 152.5 L 163.5 149.0 Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 56",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 150.0 L 27.0 154.5 L 26.0 154.5 L 26.5 150.0 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 57",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 150.0 L 199.0 154.5 L 198.0 154.5 L 198.5 150.0 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 58",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 158.0 L 63.0 160.5 L 62.0 160.5 L 62.5 158.0 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 59",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 158.0 L 163.0 160.5 L 162.0 160.5 L 162.5 158.0 Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 60",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 161.0 L 28.0 165.5 L 27.0 165.5 L 27.5 161.0 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 61",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 161.0 L 198.0 165.5 L 197.0 165.5 L 197.5 161.0 Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 62",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 164.0 L 158.5 166.0 L 157.0 165.5 L 159.5 164.0 Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 63",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 172.0 L 29.0 176.5 L 28.0 176.5 L 28.5 172.0 Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 64",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 172.0 L 197.0 176.5 L 196.0 176.5 L 196.5 172.0 Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 65",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 183.0 L 30.0 188.5 L 29.0 188.5 L 29.5 183.0 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 66",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 183.0 L 196.0 187.5 L 195.0 187.5 L 195.5 183.0 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 67",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 202.0 L 34.5 204.0 L 33.5 202.0 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 68",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 202.0 L 190.5 204.0 L 191.5 202.0 Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 69",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 224.0 L 109.0 224.5 L 106.5 225.0 L 106.5 224.0 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    desc: "l 14 p 70",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 224.0 L 119.0 224.5 L 116.5 225.0 L 116.5 224.0 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.c87e80042fc38034bd154b4c9256e7cf.svg";
export { ForwardRef as ReactComponent };